import React, { useMemo } from 'react';
import './style.scss';
import { FontAwesomeConfigurations } from '../../../utils/Configuration/FontAwesomeConfiguration';
import { NotificationModuleProps } from '../../modules/NotificationModule';
import DOMPurify from 'dompurify';

interface JUNONotificationDisplayProps extends NotificationModuleProps {
  onMarkAsRead: (id, message) => void;
}

const JUNONotificationDisplay: React.FC<JUNONotificationDisplayProps> = ({ ...props }) => {
  const sanitizedTitle = useMemo(() => {
    const sanitizedString = DOMPurify.sanitize(props.title as string, {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'target'],
    });
    // uncomment to debug what's getting removed
    // console.log('Dirty values', DOMPurify.removed);
    return sanitizedString;
  }, [props.title]);

  const sanitizedDesc = useMemo(() => {
    const sanitizedString = DOMPurify.sanitize(props.description as string, {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'target'],
    });
    // uncomment to debug what's getting removed
    // console.log('Dirty values', DOMPurify.removed);
    return sanitizedString;
  }, [props.description]);

  let avatarImage = props.image ? props.image : 'UserIcon_CrowdHub.jpg';

  return (
    <div key={props.id} className={`notification_display`}>
      <div className="notification_header">
        <div className="notification_time">
          <div className={`notification_read_icon`}>
            <i className={FontAwesomeConfigurations.ICON_CIRCLE_REGULAR}></i>
          </div>
          <div className={`notification_unread_icon`}>
            <i className={FontAwesomeConfigurations.ICON_CIRCLE_SOLID}></i>
          </div>
          <span>{props.time}</span>
        </div>
      </div>
      <div className="notification_body">
        {props.icon ? (
          <div
            className={`notification_display_icon`}
            onClick={event => {
              props.onMarkAsRead(props.id, {});
              // if external url, open in new tab
              if (props.type == CrowdHub_App.NOTIFICATION_TYPE_EXTERNAL_URL) {
                App.INSTANCE.openExternalUrl(props.url);
              } else {
                App.INSTANCE.route(props.url);
              }
            }}
          >
            <i className={props.icon}></i>
          </div>
        ) : (
          <div
            className={`notification_display_image`}
            style={{
              backgroundImage: `url(${App.INSTANCE.getImageSrc(avatarImage)})`,
            }}
            onClick={event => {
              props.onMarkAsRead(props.id, {});
              App.INSTANCE.firehoseActivity(
                null,
                null,
                App.INSTANCE.appRouter.lastRouteResolvedUrl(),
                App.INSTANCE.CurrentUser.Id,
                ANALYTICS_CONFIGURATION.FIREHOSE_CATEGORIES.CATEGORY_NOTIFICATION,
                ANALYTICS_CONFIGURATION.FIREHOSE_ACTIONS.ACTION_VIEW.value,
                App.INSTANCE.appRouter.lastRouteResolvedUrl(),
                null,
              );
              // if external url, open in new tab
              if (props.type == CrowdHub_App.NOTIFICATION_TYPE_EXTERNAL_URL) {
                App.INSTANCE.openExternalUrl(props.url);
              } else {
                App.INSTANCE.route(props.url);
              }
            }}
          ></div>
        )}
        <div
          className="notification_title_and_text"
          onClick={event => {
            props.onMarkAsRead(props.id, {});
            // if external url, open in new tab
            if (props.type == CrowdHub_App.NOTIFICATION_TYPE_EXTERNAL_URL) {
              App.INSTANCE.openExternalUrl(props.url);
            } else {
              App.INSTANCE.route(props.url);
            }
          }}
        >
          <div className="noti_title">
            <span
              dangerouslySetInnerHTML={{
                __html: sanitizedTitle,
              }}
            ></span>
          </div>
          <div className="noti_text">
            <span
              dangerouslySetInnerHTML={{
                __html: sanitizedDesc,
              }}
            ></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JUNONotificationDisplay;
